import { ModelFiltersType } from '../types/filters';

export const filterData = (data, filters: ModelFiltersType) => {
  return data.map((item) => {
    const matchesSearch = filters.search
      ? item.name.toLowerCase().includes(filters.search.toLowerCase())
      : true;

    const matchesType = filters.types?.length
      ? filters.types.includes(item.typeId)
      : true;

    const matchesGender = filters.genders?.length
      ? filters.genders.includes(item.genderId)
      : true;

    const matchesSize = filters.sizes?.length
      ? item.sizes.some((size) => filters.sizes.includes(size.sizeId))
      : true;

    return {
      ...item,
      isVisible: matchesSearch && matchesType && matchesGender && matchesSize,
    };
  });
};
